// extracted by mini-css-extract-plugin
export default {"main_section":"att_main_section__3vL9-","model_button":"att_model_button__Jno7F"};